module.exports = __webpack_public_path__ + "fonts/CenturyGothic-Italic.829a86d4.eot";